// extracted by mini-css-extract-plugin
export default {"containerStyle":"styles_containerStyle__tWgAz","textStyle":"styles_textStyle__ueN9x","linkStyle":"styles_linkStyle__WDet1"};